import { i18n } from '@/plugins/i18n';

export interface TabMetricsOptions {
    enableMixedUnits: boolean;
    axisTitles: string[];
    minMetrics: number|number[],
    maxMetrics: number|number[];
    notice?: string;
}

const defaultTabOptions: TabMetricsOptions = {
    enableMixedUnits: false,
    axisTitles: [
        i18n.t('widget-wizard.tab.metrics.first-y-axis').toString(),
        i18n.t('widget-wizard.tab.metrics.second-y-axis').toString(),
    ],
    minMetrics: 1,
    maxMetrics: 100,
};

export { defaultTabOptions };
